import { EInnStatus } from '../enums';
import {QueryService} from "./QueryService";

export type AsyncPredicate<T> = (item: T, signal?: AbortSignal) => Promise<boolean>;

export const ValidateService = {
    Inn: (value: string): EInnStatus => {
        let status = EInnStatus.Error;

        if (/[0-9]/.test(value)) {
            const numberArray = value.split('').map((char) => {
                return parseInt(char);
            });
            if (numberArray.length === 10) {
                const pattern = [2, 4, 10, 3, 5, 9, 4, 6, 8];
                const sum = pattern
                    .map((char, index) => char * numberArray[index])
                    .reduce((sum, current) => sum + current);
                const sumResult =
                    sum % 11 <= 9 ? sum % 11 : parseInt(`${sum % 11}`[`${sum % 11}`.length - 1]);

                if (sumResult === numberArray.slice(-1)[0]) {
                    status = EInnStatus.Success;
                }
            } else if (numberArray.length === 12) {
                const patternFirst = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
                const patternSecond = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];

                const sumFirst = patternFirst
                    .map((char, index) => char * numberArray[index])
                    .reduce((sum, current) => sum + current);
                const sumSecond = patternSecond
                    .map((char, index) => char * numberArray[index])
                    .reduce((sum, current) => sum + current);

                if (
                    sumFirst % 11 === numberArray.slice(-2, -1)[0] &&
                    sumSecond % 11 === numberArray.slice(-1)[0]
                ) {
                    status = EInnStatus.Success;
                }
            }
        }

        return status;
    },
    AiText: async (value: string | string[]): Promise<boolean> => {
        const texts = Array.isArray(value) ? value : [value];

        return await QueryService.transaction(`${process.env.NEXT_PUBLIC_DOMAIN_AI}/v1/validator/text`, texts)
    },
    AiImage: async (value: string | string[]): Promise<boolean> => {
        const images = Array.isArray(value) ? value : [value];

        return await QueryService.transaction(`${process.env.NEXT_PUBLIC_DOMAIN_AI}/v1/validator/image`, images)
    }
};